import { gql, useQuery } from '@apollo/client';
import { DEBT_CUSTOMER_FIELDS, DebtCustomer } from './useDebtOverviewQuery';

const DEBT_CASE_FILE = gql`
  ${DEBT_CUSTOMER_FIELDS}
  query DebtCaseFile($stripeCustomerId: String!) {
    debtCaseFile(stripeCustomerId: $stripeCustomerId) {
      customer {
        ...DebtCustomerFields
      }
      users {
        email
        lastLogin
      }
      isAgency
      isTenant
      subscription
      cancellationReason
      supportChecked
      events {
        at
        action
        actorEmail
        note
      }
      debtistActivities {
        at
        type
        comment
      }
      timeline {
        at
        kind
        title
        detail
        url
      }
    }
  }
`;

export type DebtTimelineKind =
  | 'invoice_paid'
  | 'invoice_open'
  | 'payment_failed'
  | 'mail'
  | 'support'
  | 'login'
  | 'contract'
  | 'cancellation';

export interface DebtTimelineEntry {
  at: string;
  kind: DebtTimelineKind;
  title: string;
  detail: string | null;
  url: string | null;
}

export interface DebtCaseEvent {
  at: string;
  action: string;
  actorEmail: string;
  note: string | null;
}

export interface DebtistActivity {
  at: string;
  type: string;
  comment: string | null;
}

export interface DebtCaseFile {
  customer: DebtCustomer;
  events: DebtCaseEvent[];
  debtistActivities: DebtistActivity[];
  users: Array<{ email: string | null; lastLogin: string | null }>;
  isAgency: boolean;
  isTenant: boolean;
  subscription: string | null;
  cancellationReason: string | null;
  supportChecked: boolean;
  timeline: DebtTimelineEntry[];
}

export function useDebtCaseFileQuery(stripeCustomerId: string | null) {
  return useQuery<{ debtCaseFile: DebtCaseFile | null }, { stripeCustomerId: string }>(DEBT_CASE_FILE, {
    variables: { stripeCustomerId: stripeCustomerId ?? '' },
    skip: !stripeCustomerId,
    fetchPolicy: 'network-only',
  });
}
